
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import DateRange from '@/components/DateRange.vue';
import ruleMixin from '@/minix/ruleMixin';
import imageConvert from '@/utils/image';
import zipcode from '@/zipcode.json';

const zc: { [key: string]: { [key: string]: number } } = zipcode;
@Component({
  components: {
    DateRange,
  },
  mixins: [ruleMixin],
})
export default class UserForm extends Vue {
  @Prop({ required: true }) private roles!: number[];

  @Prop({ required: true }) private userId!: string | null;

  @Prop({ required: true }) private taxId!: string;

  @Prop({ required: true }) private email!: string;

  @Prop({ required: true }) private isEnable!: boolean;

  @Prop({ required: true }) private firstName!: string;

  @Prop({ required: true }) private lastName!: string;

  @Prop({ required: true }) private gender!: number | null;

  @Prop({ required: true }) private countryCode!: string;

  @Prop({ required: true }) private mobile!: string;

  @Prop({ required: true }) private pid!: string;

  @Prop({ required: true }) private birthday!: string;

  @Prop({ required: true }) private zipcode!: number | null;

  @Prop({ required: true }) private city!: string;

  @Prop({ required: true }) private area!: string;

  @Prop({ required: true }) private address!: string;

  @Prop({ required: true }) private currentCity!: string;

  @Prop({ required: true }) private currentArea!: string;

  @Prop({ required: true }) private currentAddress!: string;

  @Prop({ required: true }) private identityIdPic!: string;

  @Prop({ required: true }) private identityIdPic2!: string;

  @Prop({ required: true }) private taxCertificationPic!: string;

  @Prop({ required: true }) private isInBlackList!: boolean;

  @Prop({ required: true }) private loading!: boolean;

  @Prop({ default: false }) private isEdit!: boolean;

  private valid = false;

  private rules = {
    taxId: [
      this.requiredRule('統一編號', this.isEdit),
      (v: string) => !v || /^\d{8}$/.test(v) || '統一編號格式錯誤',
    ],
    email: [
      this.requiredRule('E-mail', this.isEdit),
      (v: string) => !v || /.+@.+/.test(v) || 'E-mail 格式錯誤',
    ],
    mobile: [(v: string) => !v || /9\d{8}$/.test(v) || '手機格式錯誤'],
    pid: [(v: string) => !v || /^[A-Z]\d{9}$/i.test(v) || '身份證字號格式錯誤'],
  };

  private get isCompany() {
    return this.roles.some((role) => role === 2);
  }

  private get role() {
    return this.roles[0];
  }

  private set role(val: number) {
    this.change('roles', [val]);
  }

  private get genders() {
    return [
      { text: '', value: null },
      { text: '女', value: 0 },
      { text: '男', value: 1 },
      { text: '其他', value: 2 },
    ];
  }

  private get cities() {
    return Object.keys(zc);
  }

  private districts(city: string) {
    return Object.keys(zc[city] || {});
  }

  private get districtZipcode() {
    return this.city && this.area ? zc[this.city][this.area] : null;
  }

  private get namePrefix() {
    return this.isCompany ? '負責人' : '';
  }

  private requiredRule(column: string, ignoreWhenEditing: boolean = false) {
    return (v: any) => ignoreWhenEditing || !!v || `${column} 為必填`;
  }

  private async changeImage(key: string, file: File) {
    this.change(key, await imageConvert(file));
  }

  private isMP4(url: string): boolean {
    return !!url && !!url.split('.').pop()?.match(/^mp4/gi);
  }

  @Emit()
  private change(key: string, val: any) {
    return { key, value: val };
  }

  private async cancel() {
    await this.$router.back();
  }

  @Emit()
  private submit() {
    this.change('zipcode', this.districtZipcode);
    return (this.$refs.form as any).validate();
  }
}
